<template>
  <div>
    <slot></slot>
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <div class="tabBtn ">
          <div
            @click="activeName='1'"
            :class="activeName=='1'?'btn':'btnGray'"
          >在线充值</div>
          <div
            @click="activeName='2'"
            :class="activeName=='2'?'btn':'btnGray'"
          >手动转账</div>
        </div>
      </div>

      <div
        class="content"
        v-if="activeName=='1'"
        style=" height: 670px"
      >
        <div class="Account">
          <div class="rmb">
            <span class="unit">￥</span>
            <span>{{userList.money}}</span>
            <span class="tips">当前余额仅限于开放平台接口购买及消耗，话费、电费等业务预存请至微客云后台充值！</span>
          </div>
        </div>
        <div class="selectPrice">
          请选择充值金额：
        </div>
        <div class="amount">
          <div
            class="amountItem"
            :class="{active:index == isActive}"
            v-for="(item,index) in rmb"
            @click="showdifference(index,item)"
            :key="index"
          >
            {{item.key}} <i
              class="el-icon-success"
              v-if="index == isActive"
            ></i>
          </div>
          <div
            v-if="isActive==7"
            class="amountItem"
            style="border: 0;"
          >
            <el-input-number
              type='number'
              class="rule-input-edit"
              v-model="CustomAmount"
              ref="input"
              @change="inputblur()"
              @focus="inputblur()"
              controls-position="right"
            ></el-input-number>
          </div>
        </div>
        <div class="nowBtn">
          <el-button
            type="danger"
            @click="jumpPay()"
          >立即充值</el-button>
        </div>
      </div>

      <div
        class="content"
        v-if="activeName=='2'"
      >
        <div class="Account">
          <div class="rmb">
            <span class="unit">￥</span>
            <span>{{userList.money}}</span>
            <span class="tips">当前余额仅限于开放平台接口购买及消耗，话费、电费等业务预存请至微客云后台充值！</span>
          </div>
        </div>
        <div class="selectPrice">
          请选择充值方式：
        </div>
        <div class="amount">
          <div
            class="amountItem"
            :class="{active:index == isAlipay}"
            v-for="(item,index) in AlipayList"
            @click="showAlipay(index)"
            :key="index"
          >
            <div class="icons">

              <img
                :src="item.img"
                alt=""
              >

              {{item.key}}
            </div>

            <i
              class="el-icon-success"
              v-if="index == isAlipay"
            ></i>
          </div>
        </div>
        <div
          class="company"
          style="margin-top: 12px;"
          v-if=" isAlipay=='0'"
        >
          <span>公司名称：</span><span class="gray">{{AlipayInfo.alipay_name}}</span>
        </div>
        <div
          class="company"
          v-if="isAlipay=='0'"
        >
          <span>支付宝账号：</span><span class="gray">{{AlipayInfo.alipay_account}}</span>
        </div>
        <div
          class="company"
          style="margin-top: 12px;"
          v-if="isAlipay=='1'"
        >
          <span>开户名称：</span><span class="gray">{{bankInfoList.bank_account_name}}</span>
        </div>
        <div
          class="company"
          v-if="isAlipay=='1'"
        >
          <span>开户银行：</span><span class="gray">{{bankInfoList.bank_name}}</span>
        </div>
        <div
          class="company"
          v-if="isAlipay=='1'"
        >
          <span>开户账号：</span><span class="gray">{{bankInfoList.bank_account}}</span>
        </div>
        <div class="weixin">
          <div class="wxLeft">
            <div>
              <img
                :src="kefuPicUrl"
                alt=""
                srcset=""
              >
              <div class="kefu">
                客服微信
              </div>
            </div>

          </div>
          <div class="wxTips">
            <p>1.转账成功后，添加客服微信；</p>
            <p>2.将转账截图发送客服；</p>
            <p>3.客服手动添加至余额。</p>
          </div>
        </div>
        <div
          class="reminder1"
          v-if="isAlipay!='1'"
        >
          <div>
            <p>温馨提示：</p>
            <p>1. 转账备注中请写明微客云集的账号；</p>
            <p>2. 转账成功后请联系我们客服手动加款，必须打开订单详情页面。</p>
          </div>

        </div>
        <div
          class="reminder2"
          v-else
        >
          <div>
            <p>温馨提示：</p>
            <p>1. 受银行处理时间影响，建议使用在线充值或者支付宝转账</p>
            <p>2. 线下汇款直接向微客云集的对公账户汇款，系统会将款项直接匹配到您的微客云集账户（具体到账时间以银行的实际到账时间为准）；</p>
            <p>3. 专属账户暂不支持支付宝，财付通等平台转账汇款；</p>
            <p>4. 付款方的银行开户名必须与实名认证信息同名，同时本名称将是您后期开增值税专用发票的名称。企业用户必须公对公转账，否则不给予入账。</p>
          </div>

        </div>
      </div>

    </el-card>
    <el-footer></el-footer>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'Recharge',

  data () {
    return {
      userList: [],//用户信息
      AlipayInfo: [],//支付宝信息
      bankInfoList: [],//银行信息
      activeName: '1',//tab默认选项
      CustomAmount: '',//自定义金额默认
      kefuPicUrl: '',//二维码
      isActive: 0,//选中金额
      isAlipay: '0',//选中充值方式
      payMoney: 50,
      payorder: [],
      page: 'payment',
      rmb: [{ key: 50 }, { key: 100 }, { key: 200 }, { key: 500 }, { key: 1000 }, { key: 2000 }, { key: 5000 }, { key: '自定义金额' }],
      AlipayList: [
        { key: '支付宝', img: require('@/assets/imgs/icon_alipay.png') },
        { key: '银行卡', img: require('@/assets/imgs/icon_wechatpay.png') }],

    };
  },

  mounted () {
    this.getUserInfo()
  },

  methods: {
    //跳转支付包
    jumpPay () {
      apis.index.payMoneyOrder({
        money: this.payMoney
      }).then(res => {
        this.payorder = res.data
        if (res.code == 1) {
          this.$emit("watchPage", this.page, this.payorder);
          this.payorder = []
          console.log(this.payorder, "this.payorder ");
        }
      })

    },
    //用户信息
    getUserInfo () {

      apis.index.useIndex().then(res => {
        this.userList = res.data.user
        this.getpayInfo()
      })
    },
    getpayInfo () {
      apis.index.payInfo().then(res => {
        this.AlipayInfo = res.data.alipay
        this.kefuPicUrl = res.data.kefu
        this.bankInfoList = res.data.bank
      })
    },
    // 选择余额
    showdifference (index, item) {
      this.isActive = index
      this.payMoney = item.key
      if (this.isActive === 7) {
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
        this.payMoney = this.CustomAmount
      }

    },
    showAlipay (index) {
      this.isAlipay = index

    },
    inputblur () {
      this.isActive = 7
      this.payMoney = this.CustomAmount
    }
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  width: 100%;
  height: 100%;

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
  .tabBtn {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    .btn,
    .btnGray {
      cursor: pointer;
      text-align: center;
      align-items: center;
      line-height: 32px;
      width: 88px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px 0px 0px 2px;
      border: 1px solid #0b4ffc;
      color: #0b4ffc;
    }
    .btnGray {
      color: rgba(0, 0, 0, 0.65);
      border-radius: 2px 0px 0px 2px;
      border: 1px solid #d9d9d9;
    }
  }
  .content {
    padding: 10px 40px;
    .Account {
      .rmb {
        font-family: HelveticaNeue-Medium, HelveticaNeue;
        font-weight: bold;
        color: #ff4d4f;
        font-size: 24px;
        .unit {
          font-size: 12px;
        }
        .tips {
          margin-left: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    .selectPrice {
      margin: 32px 0 25px 0;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
    .amount {
      display: flex;
      flex-flow: wrap;
      width: 900px;
      .amountItem {
        margin-bottom: 20px;
        margin-right: 20px;
        cursor: pointer;
        width: 128px;
        height: 48px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        text-align: center;
        line-height: 48px;
        position: relative;
        .icons {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin-right: 3px;
          }
        }

        .el-icon-success {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 20px;
          color: #0b4ffc;
        }
        .rule-input-edit {
          width: 128px;
        }
        .rule-input-edit ::v-deep {
          .el-input__inner {
            border-radius: 0px;
            height: 48px;
          }
        }
      }

      .active {
        color: #0b4ffc;
        border: 1px solid #0b4ffc;
        border-radius: 2px;
      }
    }
    .nowBtn {
      margin-top: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      span {
        margin-left: 15px;
      }
      .gray {
        color: rgba(0, 0, 0, 0.45);
      }
      .bule {
        color: #0b4ffc;
      }
    }
    .company {
      margin-bottom: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      .gray {
        margin-left: 10px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .weixin {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      .wxLeft {
        width: 100px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 3px;
        background-color: #f5f8ff;
        margin-right: 15px;
        img {
          width: 82px;
          height: 83px;
        }
        .kefu {
          text-align: center;
          width: 100%;
          font-size: 16px;
        }
      }
      .wxTips {
        p {
          margin: 20px 0;
        }
      }
    }
    .reminder1 {
      margin-top: 32px;
      width: 600px;
      height: 126px;
      background: #fafafa;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        text-align: left;
        margin-bottom: 10px;
      }
    }
    .reminder2 {
      width: 1100px;
      padding: 10px 20px;
      background: #fafafa;
      border-radius: 2px;

      p {
        text-align: left;
        margin-bottom: 9px;
      }
    }
  }
}
</style>